import {ShapeComponent} from "set-state-compare/src/shape-component"

export default class BaseComponent extends ShapeComponent {
  // Nothing yet.
}
